import styled from 'styled-components';


export const ResetPasswordCard = styled.div`
  .ant-card-body {
    background-color: #ffffff !important;
  }

 .ant-input {
        background-color: #ffffff !important;
        border-color: #d9d9d9 !important;
        color: #000000d9 !important;
    }
`;


